import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaCalculator, FaCheckCircle, FaPaperPlane, FaPhoneAlt } from "react-icons/fa";

const Enquiry = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    city: "",
    product: "Tin Ingots",
    quantity: "100 kg",
    ratio: "63/37 (Standard)",
    notes: ""
  });

  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <div className="page-wrapper">
      <section className="page-banner">
        <div className="page-banner-container">
          <h1>Product Quotation Request</h1>
          <p>Get Competitive Market Rates &amp; Technical Specifications for Bulk Metal Alloys</p>
        </div>
      </section>

      <section className="enquiry-section">
        <div className="container">
          <div className="enquiry-box">
            <div className="enquiry-header">
              <FaCalculator className="enquiry-icon" />
              <h2>Request Instant Price Quote (RFQ)</h2>
              <p>Fill in your requirements below for custom pricing, shipping timeline to your location, and formal quotation.</p>
            </div>

            {submitted ? (
              <div className="form-success-msg center">
                <FaCheckCircle size={54} color="#38BDF8" style={{ marginBottom: '15px' }} />
                <h3>Quotation Request Submitted Successfully!</h3>
                <p>Thank you <strong>{formData.name}</strong>. Our sales representative for <strong>{formData.product}</strong> will contact you on <strong>{formData.phone}</strong> with our best commercial quotation.</p>
                <button className="btn-gold" style={{ marginTop: '20px' }} onClick={() => setSubmitted(false)}>Submit Another Quotation Request</button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="rfq-form">
                <div className="form-row-2">
                  <div className="form-group">
                    <label>Full Name *</label>
                    <input 
                      type="text" 
                      required 
                      placeholder="Your full name"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mobile Number *</label>
                    <input 
                      type="tel" 
                      required 
                      placeholder="10-digit mobile number"
                      value={formData.phone}
                      onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-row-2">
                  <div className="form-group">
                    <label>Email Address *</label>
                    <input 
                      type="email" 
                      required 
                      placeholder="Corporate or personal email"
                      value={formData.email}
                      onChange={(e) => setFormData({...formData, email: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label>Company / Firm Name</label>
                    <input 
                      type="text" 
                      placeholder="Company name"
                      value={formData.company}
                      onChange={(e) => setFormData({...formData, company: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-row-2">
                  <div className="form-group">
                    <label>Delivery City &amp; Pincode *</label>
                    <input 
                      type="text" 
                      required
                      placeholder="e.g. Ahmedabad, Mumbai, Delhi, Pune..."
                      value={formData.city}
                      onChange={(e) => setFormData({...formData, city: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label>Select Product *</label>
                    <select 
                      value={formData.product}
                      onChange={(e) => setFormData({...formData, product: e.target.value})}
                    >
                      <option value="Tin Ingots">Tin Ingots (99.9%)</option>
                      <option value="Lead Ingots">Refined Lead Ingots</option>
                      <option value="Solder Wire">Solder Wire (PCB / Electronics)</option>
                      <option value="Solder Stick 63/37">Solder Stick (63/37 Eutectic)</option>
                      <option value="Star Solder Stick">Star Solder Stick</option>
                      <option value="Small Solder Ingot">Small Solder Ingot</option>
                      <option value="Long Solder Ingot">Long Solder Ingot</option>
                      <option value="Solder Paste">Solder Paste</option>
                      <option value="Copper Axe & Round Bar">Copper Axe &amp; Copper Round Bar</option>
                      <option value="Copper Flats">Copper Flats</option>
                    </select>
                  </div>
                </div>

                <div className="form-row-2">
                  <div className="form-group">
                    <label>Estimated Order Quantity</label>
                    <input 
                      type="text" 
                      placeholder="e.g. 50 kg, 500 kg, 2 Tonnes..."
                      value={formData.quantity}
                      onChange={(e) => setFormData({...formData, quantity: e.target.value})}
                    />
                  </div>
                  <div className="form-group">
                    <label>Alloy Ratio / Purity Requirement</label>
                    <input 
                      type="text" 
                      placeholder="e.g. 63/37, 60/40, 50/50 or Pure Sn 99.9%"
                      value={formData.ratio}
                      onChange={(e) => setFormData({...formData, ratio: e.target.value})}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Additional Notes / Specific Requirements</label>
                  <textarea 
                    rows="3"
                    placeholder="Mention any custom wire thickness (mm), ingot dimensions, or packaging preferences..."
                    value={formData.notes}
                    onChange={(e) => setFormData({...formData, notes: e.target.value})}
                  ></textarea>
                </div>

                <button type="submit" className="btn-gold-submit large">
                  <FaPaperPlane style={{ marginRight: '8px' }} /> Submit Quotation Request
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Enquiry;